import {
  OfflineConfigManager,
  ClientStage,
  OfflineClientSettings,
} from '@amzn/amazon-config-store-type-script-offline-adapter';
import { MarketplaceConfigClientProvider } from '@amzn/marketplace-config-type-script-client/dist/marketplaceConfig';
import MarketplaceConfigDoc from '@amzn/amazon-config-store-type-script-offline-adapter/dist/configuration/acs_MarketplaceConfig/documents.json';
import MarketplaceConfigQueries from '@amzn/amazon-config-store-type-script-offline-adapter/dist/configuration/acs_MarketplaceConfig/queries.json';
import MarketplaceConfigHQ from '@amzn/amazon-config-store-type-script-offline-adapter/dist/configuration/acs_MarketplaceConfig/hierarchical_queries.json';
import MarketplaceConfigContext from '@amzn/marketplace-config-type-script-client/dist/marketplaceConfig/MarketplaceConfigContext';
import MarketplaceConfigDocDevo from '@amzn/amazon-config-store-type-script-offline-adapter/dist/configuration/devo/acs_MarketplaceConfig/documents.json';
import MarketplaceConfigQueriesDevo from '@amzn/amazon-config-store-type-script-offline-adapter/dist/configuration/devo/acs_MarketplaceConfig/queries.json';
import MarketPlaceConfigHQDevo from '@amzn/amazon-config-store-type-script-offline-adapter/dist/configuration/devo/acs_MarketplaceConfig/hierarchical_queries.json';

//TODO: revert to this stage calculation after StormV4 weblab dial-up
// const stage = process.env.NODE_ENV || NodeEnv.development;

// function computeClientStage(stage: string): ClientStage {
//   return stage === NodeEnv.production ? ClientStage.PROD : ClientStage.DEVO;
// }

const configManager = new OfflineConfigManager();
const isProd =
  window.location.hostname.includes('advertising.amazon') ||
  window.location.hostname.includes('advertising-japan.amazon');
const isGamma = window.location.hostname.includes('preprod');
const isNotBeta = isProd || isGamma;
const marketplaceConfigClient = configManager.createClient(
  new MarketplaceConfigClientProvider(),
  {
    load: () => ({
      documents: isNotBeta
        ? MarketplaceConfigDoc.documents
        : MarketplaceConfigDocDevo.documents,
      exactQueries: isNotBeta
        ? MarketplaceConfigQueries.queries
        : MarketplaceConfigQueriesDevo.queries,
      hierarchicalFallbackQueries: isNotBeta
        ? MarketplaceConfigHQ.queries
        : MarketPlaceConfigHQDevo.queries,
    }),
  },
  new OfflineClientSettings({
    stage: isProd ? ClientStage.PROD : ClientStage.DEVO,
  }),
);

export const getCountryCodeByMarketplace = (marketplaceId: string): string => {
  return (
    marketplaceConfigClient.getMarketplace(
      new MarketplaceConfigContext(marketplaceId),
    )?.defaultCountryCode || ''
  );
};
